import Button, { ButtonProps } from "@mui/material/Button";
import { lightBlue } from "@mui/material/colors";
import { MstaFontFamily } from "./MstaFont";
import { styled } from "@mui/material/styles";

export const MstaButton = styled(Button)<ButtonProps>(({ theme }) => ({
  textTransform: "none",
  fontSize: 24,
  padding: "6px 12px",
  border: "1px solid",
  color: "white",
  height: 60,
  lineHeight: 1.5,
  fontFamily: MstaFontFamily,
  backgroundColor: lightBlue[400],
  borderColor: lightBlue[400],
  "&:hover": {
    backgroundColor: lightBlue[600],
    borderColor: lightBlue[600],
  },
}));

export const BackButton = styled(Button)<ButtonProps>(({ theme }) => ({
  textTransform: "none",
  fontSize: 24,
  padding: "6px 6px",
  border: "1px solid",
  color: "white",
  height: 50,
  width: 50,
  minWidth: 50,
  lineHeight: 1.5,
  fontFamily: MstaFontFamily,
  backgroundColor: "#9CA4AD",
  borderColor: "#9CA4AD",
  borderRadius: "50%",
  "&:hover": {
    backgroundColor: "#72777C",
    borderColor: "#72777C",
  },
}));
